<template>
  <div class="wf-search-result description" :class="className">
    <div class="wf-search-result-top">
      <a class="wf-search-result-image-wrapper" :href="link">
        <wf-load-image
          :wrapperClass="'wf-search-result-image d-flex'"
          :imageClass="'image full-image'"
          :src="imageUrl"
          :alt="imageAltText || ''"
        />
      </a>
    </div>
    <div class="wf-search-result-content flex-fill d-flex flex-column">
      <a :href="link" class="text-decoration-none">
        <dl>
          <div class="wf-search-result-content-page">
            <dt v-html="title" class="mb-3">
            </dt>
            <dd v-if="content && content.length > 0">
              {{ content }}
            </dd>
            <dd>
              {{ date }}
            </dd>
          </div>
        </dl>
      </a>
      <template v-if="showViewButton">
        <a
          class="btn btn-white border-primary w-100 mb-2 mt-auto"
          :href="link"
        >
          View
          <span class="png-icon png-icon-icons-glyph--k-arrow-next"></span>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import WFLoadImage from "../wf-load-image.vue";

export default {
    props: ['link', 'className', 'imageUrl', 'title', 'content', 'date', 'showViewButton', 'imageAltText'],
  components: {
    "wf-load-image": WFLoadImage,
  },
  data() {
    return {};
  },
};
</script>

<style>
</style>